import { supabaseClient, useUser } from '@auth-v2';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchFavoriteSwings } from '@data';

export const FAVORITE_SWINGS_PAGE_SIZE = 6;

export const getFavoriteSwingsKey = (pageIndex: number, nameFilter: string, activeUserId = 'current') =>
    [activeUserId, 'swings', 'favorite', nameFilter, pageIndex] as const;

export const useFavoriteSwings = (pageIndex = 0, nameFilter = '', activeUserId?: string) => {
    const { data: user } = useUser();
    const userId = activeUserId ?? user?.id ?? '';

    const from = pageIndex * FAVORITE_SWINGS_PAGE_SIZE;
    const to = from + FAVORITE_SWINGS_PAGE_SIZE;

    const { data: responseData, ...rest } = useQuery({
        // Implemented according to paginated query docs.
        // See: https://tanstack.com/query/latest/docs/framework/react/guides/paginated-queries
        queryKey: getFavoriteSwingsKey(pageIndex, nameFilter || 'all'),
        queryFn: () => fetchFavoriteSwings(supabaseClient, { userId, from, to, nameFilter }),
        placeholderData: keepPreviousData,
        enabled: !!userId,
    });

    const { data, count } = responseData || {};
    return { ...rest, data, count: count || 0 };
};
